import React from 'react';

import { Grid, Section, ToggleButton } from '@gogame/components';
import { FormField, withFormFieldGroupFormField } from '@gogame/form';
import { dateFNS } from '@gogame/intl-ts';

import {
  SCHEDULE,
  PERIOD,
  DAYS,
  ON_DATE,
  DAY,
  WEEK,
  ONCE,
  MONTH,
} from './constants';
import {
  OnDateFiled,
  StartTimeField,
  DaysField,
  DaysTextField,
} from './fields';

const Schedule = withFormFieldGroupFormField({
  name: SCHEDULE,
})(({ value, formik }) => {
  const handleChange = (_e, val) => {
    let period = val;

    if (period === null) {
      period = formik?.values?.schedule?.period;
    }

    let schedule = {
      period,
      startTime: value.startTime,
    };
    if (period === ONCE) {
      schedule = { ...schedule, [ON_DATE]: dateFNS.startOfDay(new Date()) };
    }
    if (period === WEEK) {
      schedule = { ...schedule, [DAYS]: [] };
    }
    if (period === DAY) {
      schedule = { ...schedule };
    }
    if (period === MONTH) {
      schedule = { ...schedule, [DAYS]: '' };
    }

    formik.setValues({
      ...formik.values,
      schedule,
    });
  };

  return (
    <Section title={'Schedule'}>
      <Grid item container spacing={2}>
        <Grid item container xs={12} spacing={2}>
          <Grid item>
            <FormField.ToggleButtonGroup
              name={PERIOD}
              padding={'0'}
              onChange={handleChange}
            >
              <ToggleButton value={DAY}>Daily</ToggleButton>
              <ToggleButton value={WEEK}>Weekly</ToggleButton>
              <ToggleButton value={MONTH}>Monthly</ToggleButton>
              <ToggleButton value={ONCE}>Once</ToggleButton>
            </FormField.ToggleButtonGroup>
          </Grid>
          {value?.period === ONCE && (
            <Grid item>
              <OnDateFiled value={value} />
            </Grid>
          )}
          {value?.period === MONTH && (
            <Grid item>
              <DaysTextField />
            </Grid>
          )}
          <Grid item xs={3}>
            <StartTimeField />
          </Grid>
        </Grid>
        {value?.period === WEEK && (
          <Grid item xs={12}>
            <DaysField />
          </Grid>
        )}
      </Grid>
    </Section>
  );
});

export default Schedule;
